var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2553",
    d: "M0-682.665H21v21H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43527",
    "data-name": "Group 43527",
    transform: "translate(-194 -80)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16123",
    "data-name": "Rectangle 16123",
    width: 24,
    height: 24,
    transform: "translate(194 80)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2547",
    transform: "translate(195.5 764.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2549",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2551",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2557",
    transform: "translate(0.615 0.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2559",
    d: "M-146.926-506.587h-4.663v-16.078h4.922a1.23,1.23,0,0,1,1.23,1.23v2.461h13.617v12.387h-4.663",
    transform: "translate(151.589 522.665)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2561",
    transform: "translate(6.768 1.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2563",
    d: "M0,0H12.387V2.461",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2565",
    transform: "translate(10.5 11.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2567",
    d: "M0-112.431V-116",
    transform: "translate(0 116)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2569",
    transform: "translate(10.5 16.622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2571",
    d: "M0-38.769V-40",
    transform: "translate(0 40)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2573",
    transform: "translate(4.963 9.311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2575",
    d: "M-348.925-174.462a5.537,5.537,0,0,1-5.537,5.537A5.537,5.537,0,0,1-360-174.462,5.537,5.537,0,0,1-354.462-180,5.537,5.537,0,0,1-348.925-174.462Z",
    transform: "translate(359.999 180)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowForm);
export default __webpack_public_path__ + "static/media/follow-form.a2c69b487c3ba2e1aa95f9d54307ca5a.svg";
export { ForwardRef as ReactComponent };